import backup from './backup.js'
import openingBalance from './openingBalance.js'
import companyInfo from './companyInfo.js'
import users from './users.js'
import security from './security.js'
import customize from './customize.js'
import financial from './financial.js'
import product from './product.js'
import tax from './tax.js'
import shipping from './shipping.js'
import print from './print.js'
import financialYear from './financialYear.js'
import message from './message.js'
import General from './General.js'
import Treasury from './Treasury.js'
import Locale from './Locale.js'
import warehouse from './warehouse.js'
import purchase from './purchase.js'
import sale from './sale.js'
import reset from './reset.js'
import report from './report.js'

export default {
  menu: 'Settings',
  title: 'Settings',

  importantData: {
    supportNumber: 'Support number',
    balance: 'Inventory',
    employeeCount: 'Number of employees'
  },

  backup,
  openingBalance,
  companyInfo,
  users,
  security,
  customize,
  financial,
  product,
  tax,
  shipping,
  print,
  financialYear,
  message,
  General,
  Treasury,
  Locale,
  warehouse,
  purchase,
  sale,
  reset,
  report
}
